import { render, staticRenderFns } from "./TestFingerprints.vue?vue&type=template&id=0dbd66de&"
import script from "./TestFingerprints.vue?vue&type=script&lang=js&"
export * from "./TestFingerprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports